import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { TaskServiceInterface } from './definitions/task-service-interface';
import { Observable } from 'rxjs';
import { ErrorsInterface } from '../errors/errors-interface';
import { DocumentNode } from 'graphql';
import { FetchResult } from '@apollo/client/core';

interface RemoveResponse {
  task: {
    remove: {
      output: TaskServiceInterface;
      errors: ErrorsInterface;
    };
  };
}

@Injectable()
export class TaskRemoveService {
  constructor(private apollo: Apollo) {}

  remove(
    taskId,
    mutation: DocumentNode
  ): Observable<FetchResult<RemoveResponse>> {
    return this.apollo.mutate<RemoveResponse>({
      mutation: mutation,
      variables: {
        id: taskId,
      },
    });
  }
}
